import { EngagementTemplate, UserAccount } from "../data/types";
import { useCallback, useEffect, useRef } from "react";
import SignalRServiceManager from "./SignalRServiceManager";

type EngagementTemplateSignalRProps = {
    primaryAccount?: UserAccount;
    onUpsertEngagementTemplate?: (engTemplate: EngagementTemplate) => void;
}
export const useEngagementTemplateSignalR = (props: EngagementTemplateSignalRProps) => {
    const { primaryAccount, onUpsertEngagementTemplate } = props;
    const messageName = "upsertEngagementTemplate";

    // Use useRef to maintain stable reference
    const onUpsertEngagementTemplateRef = useRef(onUpsertEngagementTemplate);

    useEffect(() => {
        onUpsertEngagementTemplateRef.current = onUpsertEngagementTemplate;
    }, [onUpsertEngagementTemplate]);

    const upsertHandler = useCallback((engTemplateJson: string) => {
        try {
            const engTemplate = JSON.parse(engTemplateJson);
            onUpsertEngagementTemplateRef.current?.(engTemplate);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, engTemplateJson);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler);
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]);

    return null;
}